<template>
  <div class="studentBind location guidePage">
<section class="section">
<!-- <van-tabs v-model:active="active" animated shrink >
  <van-tab v-for="(item,index) in studentList" :title="item.studentName" :key="index">

   
  </van-tab>
</van-tabs> -->
<div v-if="studentList.length>0" >
  <div v-for="(item,index) in studentList" :key="index">
 <studentCard :propsStudentInfo='item' />

  </div>

</div>

<van-empty
  v-else
  image-size="80"
  description="暂未绑定孩子"
/>
</section>

<footer class="footer van-safe-area-bottom">
    <div class="button-add">
    <CustomButton @click="addStudent" text="+  绑定孩子"/>
    
    </div>
</footer>




<van-popup v-model:show="showDialog"  :style="{ height: '100vh',width: '100%', overflow: 'hidden' }"  title="绑定孩子" :show-confirm-button='false' >


<div  class="popup_box">
    <van-form @submit="onSubmit"  >
       <div v-show="+step == 0">
        <h5 style="margin:0 15px 20px;">您孩子就读的学校所在区域为：</h5>
        <van-field  readonly v-model="formData.areaName"  label="所在区域" placeholder="请选择学校所在区域" :rules="[{ required: true }]" @click="areaShowPicker = true;" />
         <!-- <div style="padding:10px" class="text_l">
        <p> 家长您好：</p>
        <p>感谢您亲身参与学生国家体质测试工作！</p>
        <p>正式开始之前，您需要执行以下步骤：</p>
        <p>（1）绑定学生</p>
        <p>（2）制作测训准考证</p>
        </div> -->
        <van-sticky :offset-top="'80vh'">
        <div class="buutom">
          <!-- <CustomButton class="button-on"  text="关闭" @click="showDialog=false" type='2'/> -->
          <CustomButton  text="下一步"  @click="nextStep(0)" type='1'/>
        </div>
      </van-sticky>
        </div>

        <div v-if="+step == 1">

       <div  class="popup_main">
        <h5 style="margin:0 15px 20px;">您孩子就读的学校为: {{formData.schoolName||''}}</h5>
        <van-search v-model="searchvalue" placeholder="请输入学校名称关键字搜索（如：南京）" />
        <div v-for="(item,i) in schoolColumns" :key="i">
        <van-radio-group v-model="checked">
          <van-cell-group >
              <van-cell :title="item.text"  is-link  @click="onConfirmSchool(item)">
                <template #right-icon>
                  <van-radio :name="item.value" />
                </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        </div>
        </div>
        <van-sticky :offset-top="'80vh'">
        <div class="buutom">
          <CustomButton  class="button-on"  text="上一步" @click="upStep(1)" type='2'/>
          <CustomButton   class="button-on" text="下一步"  @click="nextStep(1)" type='1'/>
        </div>
      </van-sticky>

        </div>
        <div v-if="+step == 2">
         <h5 style="margin:0 15px 20px;">学生信息</h5>
         <van-field label-width='110'  v-model="formData.studentName" type="text" name="姓名" label="姓名" placeholder="请输入姓名"
          :rules="[{ required: true }]" />
             <van-number-keyboard
          v-model="formData.idNumber"
          :show="showidNumber"
          extra-key="X"
          close-button-text="完成"
          @blur="showidNumber = false"
        />
        <van-field label-width='110'  v-model="formData.idNumber" type="text" name="身份证号" label="身份证号" placeholder="请输入身份证号"
          :rules="[{ required: true }]" />
        <!-- <van-field label-width='110' v-model="formData.inSchooleYear"  type="number" :maxlength='4' name="入学年份" label="入学年份" placeholder="请输入入学年份"
          :rules="[{ required: true }]" /> -->

<!-- ----------------- -->
        <!-- <h5 style="margin:16px 15px;">验证信息</h5> -->
        <!-- <van-field label-width='110' v-model="formData.adminTeacherName" maxlength='1' type="text" name="班主任姓氏" label="班主任姓氏" placeholder="请输入班主任姓氏"
          :rules="[{ required: true }]" />
          
        <van-field label-width='110' v-model="formData.adminTeacherSex" type="text" name="班主任性别" label="班主任性别" placeholder="请输入班主任性别"
          :rules="[{ required: true }]" > -->
    <!-- <template #input>
       <van-radio-group v-model="formData.adminTeacherSex" direction="horizontal">
        <van-radio name="男">男</van-radio>
        <van-radio name="女">女</van-radio>
      </van-radio-group>
    </template>
  </van-field> -->
        <!-- <van-field label-width='110' v-model="formData.sportTeacherName" maxlength='1' type="text" name="体育老师姓氏" label="体育老师姓氏" placeholder="请输入体育老师姓氏"
          :rules="[{ required: true }]" />
        <van-field label-width='110' v-model="formData.sportTeacherSex" type="text" name="体育老师性别" label="体育老师性别" placeholder="请输入体育老师性别"
          :rules="[{ required: true }]" >
    <template #input>
       <van-radio-group v-model="formData.sportTeacherSex" direction="horizontal">
        <van-radio name="男">男</van-radio>
        <van-radio name="女">女</van-radio>
      </van-radio-group>
    </template>
  </van-field> -->
        <van-sticky :offset-top="'80vh'">
        <div class="buutom">
          <CustomButton  class="button-on"  text="上一步" @click="upStep(2)" type='2'/>
          <CustomButton  class="button-on" text="确认" native-type="submit" type='1'/>

          <!-- <CustomButton class="button-on"  text="下一步"  @click="nextStep(2)" type='1'/> -->
        </div>
      </van-sticky>
        </div>
        <div v-if="+step == 3">
        <h5 style="margin:0 15px 20px;">学生信息验证</h5>
         <van-field label-width='110' readonly v-model="formData.studentName" type="text" name="姓名" label="姓名" placeholder="请输入姓名"
          :rules="[{ required: true }]" @click="showidNumber = true"/>
             <van-number-keyboard
          v-model="formData.idNumber"
          :show="showidNumber"
          extra-key="X"
          close-button-text="完成"
          @blur="showidNumber = false"
        />
        <van-field label-width='110' v-model="formData.idNumber" type="text" name="身份证号" label="身份证号" placeholder="请输入身份证号"
          :rules="[{ required: true }]" />
        <!-- <van-field label-width='110' v-model="formData.inSchooleYear"  type="number" :maxlength='4' name="入学年份" label="入学年份" placeholder="请输入入学年份"
          :rules="[{ required: true }]" /> -->
        <van-sticky :offset-top="'80vh'">
     <div class="buutom">
          <CustomButton  class="button-on" text="上一步" @click="upStep(3)" type='2'/>
          <CustomButton  class="button-on" text="确认" native-type="submit" type='1'/>
        </div>
      </van-sticky>
        </div>
      </van-form>
</div>
  

</van-popup>

   <van-popup v-model="schoolShowPicker" round position="bottom" :style="{ height: '55%' }">
      <van-search v-model="searchvalue" placeholder="请输入学校名称关键字搜索（如：南京）" />
      <van-picker :columns="schoolColumns" :default-index="defaultIndex" show-toolbar @cancel="schoolShowPicker = false"
        @confirm="onConfirmSchool" />
    </van-popup>
   <van-popup v-model="areaShowPicker" round position="bottom" :style="{ height: '55%' }">
        <van-area title="省市区选择" :area-list="areaList"  @cancel="areaShowPicker = false" value="320105"  @confirm="onConfirmArea"/>
    </van-popup>
    <!-- <van-button round block type="info" class="button-add" @click="addStudent">+  绑定孩子</van-button> -->
<van-dialog v-model:show="nextshowDialog" width="90%" title="提示" :show-confirm-button='false' >
  <div style="padding:10px">
    <p>首次绑定已完成，</p>
    <p>您现在可以尽情体验平台的各项功能与服务。</p>
    
    
    <!-- <p> 学生绑定成功!</p>
  <p>现在前往为您孩子制作测训准考证</p> -->
  </div>
  <div class="buutom">
    <!-- <CustomButton  text="继续绑定" @click="ContinueBinding" type='2'/> -->
    <!-- <CustomButton  text="前往制证" @click="next" type='1'/> -->
 <CustomButton  text="关闭" @click="close" type='1'/> 
      
  </div>

</van-dialog>

<van-popup v-model:show="oneshowDialog"   :style="{ height: '100vh',width: '100%', overflow: 'hidden' }"  :close-on-click-overlay='false'  title="提示" >
  <div   class="oneStepClass">
    <!-- <img class="icon" :src="require('@/assets/image/首次注册背景.svg')" /> -->
        <van-sticky :offset-top="'82vh'">
        <div class="btn">
              <CustomButton  text="开始" @click="oneshowDialog=false,showDialog=true" type='1'/>
        </div>
      </van-sticky>
  </div>

  <!-- <img class="icon" :src="require('@/assets/image/首次注册背景.png')" /> -->
  <!-- <div style="padding:10px" class="center">
   <p> 家长您好：</p>
  <p>感谢您亲身参与学生国家体质测试工作！</p>
  <p>正式开始之前，您需要执行以下步骤：</p>
  <p>（1）绑定学生</p>
  <p>（2）制作测训准考证</p>
  <div class="buutom">
    <CustomButton  text="开始" @click="oneshowDialog=false,showDialog=true" type='1'/>
  </div>
  </div> -->
  

</van-popup>

  </div>
</template>

<script>
import { Notify } from "vant";
import CustomButton from "@/components/CustomButton.vue";

import { getSchoolList} from "@/api/common";
import { getChildInfoList,bindStudentInfo} from "@/api/studentBind.js";
    import wx from 'weixin-js-sdk'
import { getChildInfoBySnCode,getSchoolInfoByCityCode} from "@/api/common.js";

import studentCard from "@/components/studentCard.vue";
import { loginByOpenId} from "@/api/bind"
import { setLocal, getLocal } from '@/utils/cookie'
import { areaList } from '@vant/area-data';

export default {
  name: "studentBind",
  components: {CustomButton,studentCard},
  data() {
    return {
      step:0,
      snCode: "",
      studentName: "",
      openId: "",
      areaList:areaList,
      areaShowPicker:false,
      formData:{
        areaName:'',
         schoolName:'',
        adminTeacherName:'',
        sportTeacherName:'',
        adminTeacherSex:'男',
        sportTeacherSex:'男'
      },
      studentInfo:{},
      active:'0',
      checked:'',
      oneshowDialog:true,
      showDialog:false,
      schoolShowPicker:false,
      nextshowDialog:false,
      showidNumber:false,
      searchvalue:'',
      schoolColumns:[],
      columnsAll:[],
      defaultIndex:'',
      studentList:[],
      statusMap:['待审核','通过','已驳回']
    };
  },
   watch: {
    searchvalue(val) {
      if (!val || !val.trim()) {
        this.schoolColumns = [];
        return;
      }
      this.getSchoolList(val.trim());
    },
  },
  created() {
    this.schoolColumns = [];
    this.getChildInfoList()
  },
  methods: {
    close(){
  wx.closeWindow()

    },
onConfirmArea(val){
console.log(val);
this.areaPickerList = val
this.formData.areaName = val[0].name + '-'+val[1].name + '-'+val[2].name
  this.formData.schoolName = '';
  this.formData.schoolCode = '';
  this.checked = ''
getSchoolInfoByCityCode({
  code:val[2].code
}).then((res)=>{
console.log(res);
   this.columnsAll = res.data.data.map((item) => {
        return { text: item.cnName, value: item.schCode };
    });
   this.schoolColumns = res.data.data.map((item) => {
        return { text: item.cnName, value: item.schCode };
   });
   if (this.schoolColumns.length>0) {
  this.checked = this.schoolColumns[0].value
  this.formData.schoolName = this.schoolColumns[0].text
  this.formData.schoolCode = this.schoolColumns[0].value
   }
console.log(res);
// 下一步
this.step = 0 + 1

})
this.areaShowPicker =false

},
nextStep(val){
  if (val == 0&&this.formData.areaName=='') {
  this.$notify({ type: "warning", message: '请选择学校所在区域！' });
  return
}
if (val == 1&&this.formData.schoolName=='') {
  this.$notify({ type: "warning", message: '请选择学校！' });
  return
}else if (val==2) {

  if (this.formData.adminTeacherName==''||this.formData.adminTeacherSex==''||
  this.formData.sportTeacherName==''||this.formData.sportTeacherSex=='') {
  this.$notify({ type: "warning", message: '请填写全部信息！' });
    return
  }
}
this.step = val + 1

},
upStep(val){
this.step = val -1
},

    ContinueBinding(){
    this.nextshowDialog=false
    this.showDialog =true
    },
    // next(){
    //   this.$router.push({path:'addAdmissionGuide',query:{studentInfo:JSON.stringify(this.studentInfo)}})
    // },
    getChildInfoList(){
getChildInfoList({
  status:'-1'
}).then(res=>{
  this.studentList = res.data.data||[]
  this.studentList?.forEach(el=>{
    if (el.sex=='男') {
      this.$set(el,'sexImg',require("@/assets/image/男.png") )
    }else if(el.sex=='女'){
      this.$set(el,'sexImg',require("@/assets/image/女.png") )
    }
  })
  
console.log(res);
})
    },
    getSchoolList(keyword) {
      if (!keyword || !keyword.trim()) {
        this.schoolColumns = [];
        return;
      }
      getSchoolList({ keyword: keyword.trim() }).then((res) => {
        const body = res?.data?.body || res?.data?.data || res?.data || [];
        if (Array.isArray(body)) {
          this.schoolColumns = body.map((item) => {
            return { text: item.name || item.schName || '', value: item.code || item.schCode || '' };
          }).filter(i => i.text && i.value);
        } else {
          this.schoolColumns = [];
        }
      }).catch(err => {
        console.warn("获取学校失败", err);
        this.schoolColumns = [];
      });
    },
    addStudent(){
      this.formData = {}
      this.showDialog = true
    },

    
  async  onSubmit(){
console.log(this.formData);
let data = {...this.formData}
 await loginByOpenId({openId:getLocal('openId')}).then(res=>{
              console.log(res);
              setLocal("userInfo", JSON.stringify(res.data.body));
              setLocal("Authorization", res.data.body.token);


               bindStudentInfo(data).then(res=>{
    this.$notify({ type: "success", message: '绑定成功' });
    this.getChildInfoList()
       this.showDialog = false;
    this.nextshowDialog=true
    // this.getChildInfoBySnCode()  
})

              })




 

    },

// 查询学生信息
    getChildInfoBySnCode(){
getChildInfoBySnCode({
    snCode:this.formData.idNumber,
    schoolCode:this.formData.schoolCode,
}).then(res=>{
  let data = res.data.body
  let studentInfo = {
studentName:data.studentName,
sex:data.sex,
birthDay:data.birthDay,
schoolName:data.schoolName,
schoolCode:data.schoolCode,
studentGradeName:data.studentGradeName||'',
adminClassName:data.className||'',
snCode:data.snCode,
}
this.studentInfo = JSON.parse(JSON.stringify(studentInfo))
 this.formData={
        areaName:'',
         schoolName:'',
        adminTeacherName:'',
        sportTeacherName:'',
        adminTeacherSex:'男',
        sportTeacherSex:'男'
      },
    this.showDialog = false;
    this.nextshowDialog=true
})
    },
    // 选择学校
       onConfirmSchool(val) {
        this.formData.schoolName = val.text;
        this.formData.schoolCode = val.value;
        this.checked = val.value
        //  this.$dialog
        // .alert({
        //   message: `是否确认就读学校为：${val.text}`,
        //   showCancelButton: true
        // })
        // .then(() => {
        // this.formData.schoolName = val.text;
        // this.formData.schoolCode = val.value;
        // // 下一步
        // this.step = 1 + 1

        // })
        // .catch(() => {
        //   // on cancel
        // })
       
        // this.schoolShowPicker = false;
    },
    onRemove(){
        this.$dialog
        .alert({
          message: '是否确认解除绑定?',
          showCancelButton: true
        })
        .then(() => {
           
        })
        .catch(() => {
          // on cancel
        })
    },

  },
};
</script>


<style scoped lang="less">
.guidePage{
  ::v-deep .van-overlay{
    background-color: #F2F4F6;
  }
}
.studentBind{
  display: flex;
  flex-direction: column;
  overflow-y: auto;

 
  .section{
    flex: 1;
    overflow: scroll;
  }
  .footer{
    display: flex;
    margin-bottom: 6%;
    margin-top: 5%;
    justify-content: space-around;
  }
  }
.dialogBox{
  max-height: 100vh;
  overflow: scroll;
  ::v-deep .van-cell{
    line-height: 28px;
  }
}


.popup_box {
  height: 100vh;
  background-color: #fafafa;
  overflow: hidden;
  position: relative;
  padding-top: 20px;

  .popup_bottom {
    width: 100%;
    height: 1.31rem;
    position: absolute;
    bottom: 0;
    display: flex;
  }
  .popup_main {
    background-color: #fafafa;
    height: 80vh;
    overflow-y: scroll;
  }
}

.studentCard{
  background-color: #fff;
  border-radius: 10px;
  margin: 8px;
  padding: 15px;
   box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);
  .studentCard_title{
    display: flex;
    justify-content: space-between;
    font-size: 25px;
    font-weight: 600;
  }
  .studentCard_value{
    color: #ccc;
  }
}
.buutom {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  .button-on{
    width: 48%;
}
}

  .button-add{
    width: 80%;
    margin: 0 auto;
    margin-top: 50px;
}
.text_l{
  text-align: left;
  font-size: 3vw;
}
.oneStepClass{
  height: 100vh;
  width: 100%;
  text-align: center;
  // background-image: url('../../assets/image/首次注册背景.svg');
  background-image: url('../../assets/image/首次注册背景.jpg');
  background-repeat: no-repeat;
  background-size: cover;
    // background-image: url('../../assets/image/首次注册背景.svg');
    // background-size: 100% 100%;
    // background-repeat: no-repeat;

    .btn{
      width: 60%;
      margin: 0 auto;
       display: flex;
       align-items: center;
        justify-items: center;
      
    }
    .icon {
      // position: relative;
      // height: 100vh;
      width: 100%;
    }
    // .center{
    //   position: absolute;
    //   top: 20px;
    //   left: 15px;
    //   margin-right: 15px;
    //   text-align: left;
    // }
}

</style>
